import { h } from 'preact'

interface SingleOptionProps {
  bankId?: string
  singleOption: string
  selectedOption?: string
  handleSetClickedOption: (option: string) => void
}

const SingleOption = ({ handleSetClickedOption, bankId, singleOption, selectedOption }: SingleOptionProps) => {
  const setClickedOption = () => {
    bankId === undefined ? handleSetClickedOption(singleOption) : handleSetClickedOption(bankId)
  }

  const isSelectedOption = singleOption === selectedOption ? 'hero-form__single-option--fw-700' : ''

  return (
    <div
      className={`hero-form__single-option ${isSelectedOption}`}
      onClick={setClickedOption}
    >
      {singleOption}
    </div>
  )
}

export default SingleOption
